export default __webpack_public_path__ + "static/media/q23_01.5ebf1efb.png";